import { Component, input } from '@angular/core';

import { ChatbotConfig } from '@shared/index';

@Component({
    selector: 'app-hint-memory-required',
    templateUrl: './hint-memory-required.component.html',
    imports: []
})
export class HintMemoryRequiredComponent {
  public readonly botConfig = input.required<ChatbotConfig>();



}
